



















import { Component,  Vue, Prop } from 'vue-property-decorator';
import { detail } from '@/api/api';
import { Notify } from 'vant';
import loading from '@/components/loading/loading.vue';

@Component({
    name: 'query-result',
    components: {
        loading
    }
})

export default class QueryResult extends Vue {
    private lineName: string = '';
    private startTime: string = '';
    private endTime: string = '';
    private start: any = {};
    private end: any = {};
    private stations: any[] = [];
    private sum: number = 0;
    private loading: boolean = true;

    // mounted
    private mounted() {
        const lineId = this.$route.query.lineId;
        const direction = this.$route.query.direction;
        const areaCode = localStorage.getItem('areaCode');
        detail({lineId, direction, areaCode}).then((res: any) => {
            // console.log(res);
            const busStations: any[] = res.data.busStations;
            const busLine: any = res.data.busLine;
            if (direction === '1') {
                this.startTime = busLine.upLinkStartTime;
                this.endTime = busLine.upLinkEndTime;
            } else {
                this.startTime = busLine.downLinkStartTime;
                this.endTime = busLine.downLinkEndTime;
            }
            this.sum = busStations.length;
            this.lineName = busStations[0].lineName;
            this.start = busStations[0];
            this.end = busStations[busStations.length - 1];
            this.stations = busStations.slice(1, busStations.length - 1);
            this.loading = false;
        });
    }

    // methods
    // 详情
    private goInfo(): void {
        const lineId = this.$route.query.lineId;
        const direction = this.$route.query.direction;
        const lineCode = this.$route.query.lineCode;
        this.$router.push({
            path: '/info',
            query: {
                lineId,
                direction,
                lineCode
            }
        });
    }
}
